/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMTIsOC40TDUuOSwxNC41TDcsMTUuNkwxMiwxMC42TDE3LDE1LjZMMTgsMTQuNUwxMiw4LjRaIiBmaWxsPSIjMTExMTExIi8+PC9zdmc+";